export default "__VITE_ASSET__Ck$Ng8Ku__"